import { getRandomId } from 'core/utils/getRandomId';
import {
  AnalysisRequirementInput,
  CandidateStatus,
  Requirement
} from 'services/candidate/types';

const getCandidateFiltersFromFilterValues = ({
  filterId,
  value
}: {
  filterId?: string;
  value: string | CandidateStatus | undefined;
}) => {
  if (filterId === 'status') {
    return {
      status: {
        eq: value
      }
    };
  }

  return undefined;
};

export const requirementsGeneratedMapper = (
  requirements: Requirement[]
): AnalysisRequirementInput[] => {
  return requirements.map((requirement) => ({
    // This is to ensure that the id is not null so the React key is not undefined
    key: getRandomId(),
    content: requirement.content,
    isMandatory: requirement.isMandatory || false,
    weight: 1
  }));
};

export { getCandidateFiltersFromFilterValues };
